(() => {
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.calicosquid.savorrecipes';
  const IKI_SAVOR_URL = '/pages/iron-kitchen-x-savor';
  const RECIPES_URL = '/pages/recipes';

  const userAgent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isChromeAndroid = isAndroid && /Chrome\/\d+/i.test(userAgent) && !/EdgA|OPR|SamsungBrowser/i.test(userAgent);

  function androidIntentUrl(deepLink) {
    const route = deepLink.replace(/^savor:\/\//i, '');
    return `intent://${route}#Intent;scheme=savor;package=com.calicosquid.savorrecipes;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
  }

  function previewThemeIdFor(trigger) {
    const params = new URLSearchParams(window.location.search);
    return params.get('preview_theme_id') || trigger.dataset.savorPreviewThemeId || '';
  }

  function previewAwareDeepLink(trigger, deepLink) {
    if ((trigger.dataset.savorContext || 'recipe') !== 'recipe') return deepLink;

    const previewThemeId = previewThemeIdFor(trigger);
    if (!previewThemeId) return deepLink;

    const previewSource = trigger.dataset.savorPreviewSource;
    if (!previewSource) return deepLink;

    try {
      const sourceUrl = new URL(previewSource, window.location.origin);
      sourceUrl.searchParams.set('preview_theme_id', previewThemeId);
      return `savor://create?url=${encodeURIComponent(sourceUrl.toString())}`;
    } catch (_) {
      return deepLink;
    }
  }

  function previewAwareInternalUrl(trigger, href) {
    if (!href || !href.startsWith('/')) return href;

    const previewThemeId = previewThemeIdFor(trigger);
    if (!previewThemeId) return href;

    if (href === RECIPES_URL) {
      return `/pages/iron-kitchen-x-savor?preview_theme_id=${encodeURIComponent(previewThemeId)}&view=recipes`;
    }

    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
      return href;
    }
  }

  function openAndroid(deepLink) {
    if (isChromeAndroid) {
      window.location.href = androidIntentUrl(deepLink);
      return;
    }

    let fallbackTimer;
    const cancelFallback = () => {
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
    const handleVisibility = () => {
      if (document.hidden) cancelFallback();
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('pagehide', cancelFallback, { once: true });
    fallbackTimer = window.setTimeout(() => {
      cancelFallback();
      window.location.href = PLAY_STORE_URL;
    }, 1800);

    window.location.href = deepLink;
  }

  function modalCopy(platform, context) {
    if (platform === 'ios') {
      if (context === 'claim') {
        return {
          kicker: 'iPhone & iPad',
          title: 'Savor for iOS is coming soon.',
          body: 'The free Iron Kitchen theme will be waiting when Savor lands on iPhone. Until then, every Iron Kitchen recipe is complete and cookable right here — Savor is an optional extra, not a requirement.',
          primaryLabel: 'Explore IKI recipes',
          primaryHref: RECIPES_URL,
          secondaryLabel: 'Stay here'
        };
      }

      return {
        kicker: 'iPhone & iPad',
        title: 'Savor for iOS is coming soon.',
        body: 'You do not need Savor to use this recipe. Keep cooking it right here on Iron Kitchen today, and keep an eye on Iron Kitchen × Savor for the iPhone release.',
        primaryLabel: 'Iron Kitchen × Savor',
        primaryHref: IKI_SAVOR_URL,
        secondaryLabel: 'Keep cooking here'
      };
    }

    if (context === 'claim') {
      return {
        kicker: 'Savor availability',
        title: 'Savor is currently on Android.',
        body: 'Install Savor on your Android phone, then return to Iron Kitchen and claim the free IKI theme. iPhone and iPad support is coming soon.',
        primaryLabel: 'Get Savor for Android',
        primaryHref: PLAY_STORE_URL,
        secondaryLabel: 'Stay here'
      };
    }

    return {
      kicker: 'Savor availability',
      title: 'Savor is a mobile app.',
      body: 'Savor is currently available on Android, with iPhone and iPad support coming soon. You do not need the app to use this recipe — keep cooking right here on Iron Kitchen.',
      primaryLabel: 'Get Savor for Android',
      primaryHref: PLAY_STORE_URL,
      secondaryLabel: 'Keep cooking here'
    };
  }

  function openModal(trigger) {
    const modal = document.querySelector('[data-savor-platform-modal]');
    if (!modal) return;

    const copy = modalCopy(isIOS ? 'ios' : 'desktop', trigger.dataset.savorContext || 'recipe');
    const kicker = modal.querySelector('[data-savor-modal-kicker]');
    const title = modal.querySelector('[data-savor-modal-title]');
    const body = modal.querySelector('[data-savor-modal-body]');
    const primary = modal.querySelector('[data-savor-modal-primary]');
    const secondary = modal.querySelector('[data-savor-modal-secondary]');

    if (kicker) kicker.textContent = copy.kicker;
    if (title) title.textContent = copy.title;
    if (body) body.textContent = copy.body;
    if (primary) {
      const primaryHref = previewAwareInternalUrl(trigger, copy.primaryHref);
      primary.textContent = copy.primaryLabel;
      primary.href = primaryHref;
      primary.target = primaryHref.startsWith('http') ? '_blank' : '_self';
      primary.rel = primaryHref.startsWith('http') ? 'noopener' : '';
    }
    if (secondary) secondary.textContent = copy.secondaryLabel;

    modal.hidden = false;
    document.documentElement.classList.add('iki-savor-modal-open');
    const closeButton = modal.querySelector('[data-savor-modal-close]');
    if (closeButton) closeButton.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('iki-savor-modal-open');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-savor-action]');
    if (trigger) {
      const baseDeepLink = trigger.dataset.savorDeepLink || trigger.getAttribute('href');
      if (!baseDeepLink || !baseDeepLink.startsWith('savor://')) return;

      const deepLink = previewAwareDeepLink(trigger, baseDeepLink);

      event.preventDefault();
      if (isAndroid) {
        openAndroid(deepLink);
      } else {
        openModal(trigger);
      }
      return;
    }

    const closeControl = event.target.closest('[data-savor-modal-close]');
    if (closeControl) {
      const modal = closeControl.closest('[data-savor-platform-modal]');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('[data-savor-platform-modal]:not([hidden])');
    if (modal) closeModal(modal);
  });
})();
